export class TimeSlot {
  id: number;
  lessonId: number;
  start: Date;
  end: Date;

  constructor() {}
}
